import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useRouter } from 'next/router';
import { SearchInput, Wrapper } from './SidebarSearchStyled';
import { ISidebarSearchProps } from './interfaces';

const SidebarSearch: React.FC<ISidebarSearchProps> = () => {
  const [searchValue, setSearchValue] = useState('');
  const router = useRouter();

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setSearchValue(event.target.value);

  const redirectToSearch = () => {
    router.push(`/search?q=${searchValue}`);
  };

  const onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') redirectToSearch();
  };

  return (
    <Wrapper>
      <SearchInput
        value={searchValue}
        type="text"
        autoComplete="off"
        name="search"
        placeholder="Search..."
        onKeyPress={onKeyPress}
        onChange={onChange}
      />
      <FontAwesomeIcon
        width={19}
        height={19}
        icon={faSearch}
        onClick={redirectToSearch}
      />
    </Wrapper>
  );
};

export default SidebarSearch;
